import { render, staticRenderFns } from "./riskAssessmentDescription.vue?vue&type=template&id=c625362c&scoped=true"
import script from "./riskAssessmentDescription.vue?vue&type=script&lang=js"
export * from "./riskAssessmentDescription.vue?vue&type=script&lang=js"
import style0 from "./riskAssessmentDescription.vue?vue&type=style&index=0&id=c625362c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c625362c",
  null
  
)

export default component.exports